import React, { useState, useEffect } from 'react';
import { Alert, Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField } from '@mui/material';

const AddDoctorModal = ({ open, onClose, onSubmit, initialData = {} }) => {
    const [saving, setSaving] = useState(false);
    const [error, setError] = useState('');
    const [formData, setFormData] = useState({
        name: '',
        lastname: '',
        title: '',
        phone: '',
        email: '',
        password: '' // Only required when adding a new user
    });

    // Update formData when initialData changes (when editing)
    useEffect(() => {
        setError('');
        if (open) {
            setFormData({
                name: initialData?.name || '',
                lastname: initialData?.lastname || '',
                title: initialData?.title || '',
                phone: initialData?.phone || '',
                email: initialData?.email || '',
                password: ''  // Password should not be prefilled for security reasons
            });
        }
    }, [initialData, open]);

    const handleChange = (e) => {
        const { name, value } = e.target;
        setFormData((prevData) => ({ ...prevData, [name]: value }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSaving(true);
        setError('');
        try { await onSubmit({ ...formData, id: initialData?.id }); }
        catch (err) { setError(err.message); }
        finally { setSaving(false); }
    };
    

    return (
        <Dialog open={open} onClose={onClose}>
            <DialogTitle>{initialData?.name ? 'Edit Doctor' : 'Add Doctor'}</DialogTitle>
            <DialogContent>
                {error && <Alert severity="error" sx={{ mt: 2 }}>{error}</Alert>}
                <div className="row">
                    <div className="col-12 col-lg-6">
                        <TextField
                            label="First Name"
                            name="name"
                            value={formData.name}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        <TextField
                            label="Last Name"
                            name="lastname"
                            value={formData.lastname}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        <TextField
                            label="Title"
                            name="title"
                            value={formData.title}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        <TextField
                            label="Phone"
                            name="phone"
                            value={formData.phone}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        <TextField
                            label="Email"
                            name="email"
                            value={formData.email}
                            onChange={handleChange}
                            fullWidth
                            margin="normal"
                        />
                    </div>
                    <div className="col-12 col-lg-6">
                        {!initialData?.name && (
                            <TextField
                                label="Password"
                                name="password"
                                type="password"
                                value={formData.password}
                                onChange={handleChange}
                                fullWidth
                                margin="normal"
                            />
                        )}
                    </div>
                </div>

            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} disabled={saving}>Cancel</Button>
                <Button onClick={handleSubmit} variant="contained" color="primary" disabled={saving}>
                    {saving ? 'Saving…' : initialData?.name ? 'Update' : 'Add'}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default AddDoctorModal;
